<template lang="pug">
  .download-new-csv(:class="wrapClass")
    span.cap-icon.cap-icon_circle.cap-icon-document
    span
      template(v-if="hasRequiredData")
        a(:href="downloadUrl")
          //Скачать выписку по счету <strong>{{accountNumber}}</strong>
          i18n(path="downloadUrlTitle")
            template(v-slot:account)
              strong {{accountNumber}}
        //.hint
          //за период {{periodBegin}} &mdash; {{periodEnd}}
          i18n(path="downloadHint")
            template(v-slot:begin) {{periodBegin}}
            template(v-slot:end) {{periodEnd}}
      template(v-else)
        .no-data-alt {{$t('Выберите счет, чтобы скачать выписку')}}

</template>

<script lang="ts">

import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';

@Component({
  name: 'HistoryAccountEntriesDownloadButton',
})
export default class HistoryAccountEntriesDownloadButton extends Vue {
  @Prop({required: true})
  accountNumber!: string

  @Prop({required: false, default: null})
  periodBegin: string | null

  @Prop({required: false, default: null})
  periodEnd: string | null

  get hasRequiredData(): boolean {
    return Boolean(this.accountNumber && this.accountNumber.match(/^.{1,3}\d{5,}$/));
    // && this.periodBegin && this.periodBegin.match(/\d{1,2}\.\d{1,2}\.\d{4}/)
    // && this.periodEnd && this.periodEnd.match(/\d{1,2}\.\d{1,2}\.\d{4}/));
  }

  get downloadUrl(): string {
    return `/finance/historyaccount?account=${this.accountNumber}`
      + (this.periodBegin ? '&begin=' + this.periodBegin : '')
      + (this.periodEnd ? '&end=' + this.periodEnd : '');
  }

  get wrapClass() {
    return {
      'required-error': !this.hasRequiredData,
      'show-link': this.hasRequiredData,
    };
  }
}
</script>

<style scoped lang="less">
.download-new-csv {
  a {
    //text-decoration: underline;
    //color: #80bd1c;
  }

  &.required-error {
    .cap-icon_circle {
      background: #eee;
      color: #bbb;
    }

    .no-data-alt {
      color: #888888;
    }
  }

  .hint {
    font-size: 80%;
    color: #888888;
    line-height: 1.2em;
  }

  display: grid;
  grid-gap: 10px;
  align-items: center;
  grid-template-columns: min-content auto;
}
</style>

<i18n>
{
  "en": {
    "Выберите счет и период, чтобы скачать выписку": "In order to get account statement please select some account and period",
    "Выберите счет, чтобы скачать выписку": "Please select any account to download statement",
    "downloadUrlTitle": "Download account {account} statement",
    "downloadHint": "for period {begin} - {end}"
  },
  "ru": {
    "downloadUrlTitle": "Скачать выписку по счету {account}",
    "downloadHint": "за период {begin} - {end}"
  }
}
</i18n>
